import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from "@angular/core";
import { Observable } from "rxjs";
import { debounceTime, distinctUntilChanged, map } from "rxjs/operators";
import { Dominio, Municipio } from "src/app/model/dominio-operacao.model";
import { OperacaoCreditoLivre, OutrasGarantias } from "src/app/model/operacao-credito-livre.model";
import { OperacaoGarantida } from 'src/app/model/operacao-garantida.model';
import { ControleHabilitacaoCamposService } from '../../../controle-habilitacao-campos.service';
import { ModalidadeService } from 'src/app/shared/services/modalidade.service';
import { ModalidadeGarantiaService } from "../../../../../modalidade_garantia/modalidade-garantia.service";
import { MODALIDADE_GARANTIA_FGBS, MODALIDADE_GARANTIA_FGT, MODALIDADE_GARANTIA_PEAC_CS_RS, ModalidadeGarantia } from "../../../../../../model/modalidade_garantia.model";
import { OperacaoCreditoLivreService } from "../../../operacao-credito-livre.service";
import { OperacaoCreditoLivreDominioModalidade } from "src/app/model/operacao-credito-livre-dominio-modalidade";
import { BnLoadingService } from "@bndes/bndes-ux4/bndes-angular-utils";
import { OperacaoCreditoLivreDominioIndexador } from "src/app/model/operacao-credito-livre-dominio-indexador";
import { DatePipe } from "@angular/common";
import { OperacaoRepasseBndes, PERIODICIDADE_AMORTIZACAO } from "src/app/model/operacao-repasse-bndes.model";


@Component({
    selector: 'aba-operacao-garantida',
    templateUrl: 'aba-operacao-garantida.component.html',
    standalone: false
})
export class AbaOperacaoGarantidaComponent implements OnInit, OnChanges, OnDestroy {
    @Input()
    public operacao: OperacaoCreditoLivre;
    @Input()
    public modoEdicao: Boolean;
    @Input()
    public emInclusao: Boolean;
    @Input()
    public modoAditivo: Boolean;
    @Input()
    public dadosDominio: Dominio;
    @Input()
    public model: OperacaoGarantida;
    @Input()
    public modoRetificacao: Boolean;
    @Input()
    public gestorConsulta: Boolean;


    @Output() opcaoEnvioEmit = new EventEmitter<string>();
    @Output() alteracaoClienteFinalAditivoEmit = new EventEmitter<Boolean>();

    public modalidadeGarantia: string;
    public modalidadeGarantiaDTO: ModalidadeGarantia;
    public outrasGarantias: OutrasGarantias[];
    public percentuaisPorModalidade: number[];
    public modalidades: OperacaoCreditoLivreDominioModalidade[] = [];
    public indexadores: OperacaoCreditoLivreDominioIndexador[] = [];
    public indexadorAtualizacaoGarantia: string;
    carregandoModalidades = false;
    carregandoIndexadores = false;
    primeiroAcesso: boolean = true;
    honraComAtualizacaoGarantida: boolean = false;


    constructor(
        private controleHabilitacaoCamposService: ControleHabilitacaoCamposService,
        private modalidadeService: ModalidadeService,
        private modalidadeGarantiaService: ModalidadeGarantiaService,
        protected operacaoCreditoLivreService: OperacaoCreditoLivreService,
        private bnLoadingService: BnLoadingService,
        private datePipe: DatePipe
    ) {

    }

    onChangeDataContratacao(dataContratacao?: Date) {
        if (dataContratacao instanceof Date) {
            this.carregarModalidades(dataContratacao);
        }
    }

    async carregarModalidades(dataContratacao?: Date) {
        if (!this.carregandoModalidades) {
            try {
                this.carregandoModalidades = true;
                let dataReferencia = null;
                if (dataContratacao != null) {
                    dataReferencia = this.datePipe.transform(dataContratacao, 'YYYYMMdd');
                }
                this.bnLoadingService.bloqueiaTela();
                this.modalidades = await this.operacaoCreditoLivreService.buscaDominioModalidades(this.operacao.codigoTipoOperacao, dataReferencia).toPromise();
            } catch (err) {
                console.log('Erro ao carregar os modalidades', err);
            } finally {
                this.carregandoModalidades = false
                this.bnLoadingService.liberaTela();
            }
        }
    }


    onChangeModalidade(modalidadeCodigo?: string) {
        if (modalidadeCodigo) {
            this.carregarIndexadores(modalidadeCodigo);
        } else {
            this.indexadores = [];
        }
    }

    carregarIndexadores(modalidadeCodigo: string) {
        try {
            this.carregandoIndexadores = true;
            let dataReferencia = null;
            if (this.operacao.dataContratacao != null) {
                dataReferencia = this.datePipe.transform(this.operacao.dataContratacao, 'YYYYMMdd');
            }
            this.bnLoadingService.bloqueiaTela();
            this.operacaoCreditoLivreService.buscaDominioIndexadores(this.operacao.codigoTipoOperacao, dataReferencia, modalidadeCodigo).subscribe(index => this.indexadores = index);
        } catch (err) {
            console.log('Erro ao carregar as indexadores', err);
        } finally {
            this.carregandoIndexadores = false
            this.bnLoadingService.liberaTela();
        }
    }

    ngOnInit() {
        this.modalidadeService.modalidade$.subscribe(modalidade => this.modalidadeGarantia = modalidade);

        this.modalidadeGarantiaService.buscarModalidade().subscribe((modalidade: any) => {
            this.modalidadeGarantiaDTO = modalidade;
            this.percentuaisPorModalidade = modalidade.percentuaisGarantiaPermitidos;
            this.tratarPercentualGarantido();
            this.honraComAtualizacaoGarantida = this.modalidadeGarantiaDTO.utilizaTaxaAtualizacaoGarantia;
            console.log(this.modalidadeGarantiaDTO);
            console.log(this.honraComAtualizacaoGarantida);

        });

    }

    public ngOnDestroy() {
        console.log('Destroy');
    }


    ngOnChanges(changes: SimpleChanges): void {
        this.outrasGarantias = this.operacao.outrasGarantias;
        if (this.primeiroAcesso
            && this.operacao
            && this.operacao.codigoTipoOperacao) {
            this.carregarModalidades();
            this.primeiroAcesso = false;
        }
        if (this.indexadores.length === 0
            && this.operacao
            && this.operacao.dataContratacao != null
            && this.operacao.modalidade != null) {
            this.carregarIndexadores(this.operacao.modalidade);
        }
    }

    tratarPercentualGarantido() {
        if (this.operacao?.percentualGarantido) {
            this.operacao.percentualGarantido = Number(this.operacao.percentualGarantido);
        }
    }

    adicionarGarantia() {
        const operacaoCreditoLivre: OperacaoCreditoLivre = <OperacaoCreditoLivre>this.model;
        operacaoCreditoLivre.outrasGarantias.push(new OutrasGarantias());
    }

    removerGarantia(i) {
        const operacaoCreditoLivre: OperacaoCreditoLivre = <OperacaoCreditoLivre>this.model;
        operacaoCreditoLivre.outrasGarantias.splice(i, 1);
    }

    atribuiGarantia(tipoGarantia: string, i) {
        const operacaoCreditoLivre: OperacaoCreditoLivre = <OperacaoCreditoLivre>this.model;
        operacaoCreditoLivre.outrasGarantias[i].tipoGarantia = tipoGarantia;
    }

    atribuiPercentualGarantido(percentualGarantia: number) {
        const operacaoCreditoLivre: OperacaoCreditoLivre = <OperacaoCreditoLivre>this.model;
        operacaoCreditoLivre.percentualGarantido = percentualGarantia;
    }

    nomeModalidadeOperacao(idModalidadeOperacao: string) {
        return this.dadosDominio.modalidades.filter(item => item.id === idModalidadeOperacao)[0]?.nome;
    }

    atribuiIndexador(idIndexador: string) {
        const operacaoCreditoLivre: OperacaoCreditoLivre = <OperacaoCreditoLivre>this.model;
        operacaoCreditoLivre.indexadorTaxaJuros = idIndexador;
        if (idIndexador) {
            operacaoCreditoLivre.detalheCreditoLivre.nomeIndexadorTaxaJuros = this.dadosDominio.indexadores.filter(i => i.id == <unknown>idIndexador)[0].nome;
        }
        else {
            operacaoCreditoLivre.detalheCreditoLivre.nomeIndexadorTaxaJuros = undefined;
        }
    }

    atribuiMunicipioInvestimento(obj) {
        (<OperacaoCreditoLivre>this.model).codigoIbgeMunicipioInvestimento = obj.item.id;
        (<OperacaoCreditoLivre>this.model).detalheCreditoLivre.nomeMunicipioInvestimento = obj.item.nome;
    }

    nomeTipoECGRepasse(tipoECGRepasse: string) {
        switch (tipoECGRepasse) {
            case '2':
                return 'FGI PEAC - ECG a ser somado ao valor solicitado';
            case '3':
                return 'FGI PEAC - ECG via boleto';
            case '4':
                return 'FGI PEAC - ECG já está dentro do valor solicitado';
            case '5':
                return 'FGEnergia - ECG a ser somado ao saldo';
            case '7':
                return 'FGEnergia - ECG já está dentro do saldo';
            case '8':
                return 'FGI Tradicional - ECG a ser somado ao valor solicitado';
            case '9':
                return 'FGI Tradicional - ECG já está dentro do valor solicitado';
            case '10':
                return 'FGI Tradicional - ECG via boleto';
            case '11':
                return 'FGI PEAC Crédito Solidário RS';
            case '13':
                return 'FGI PEAC Crédito Solidário RS - ECG via boleto';
            case '14':
                return 'FG SEBRAE - ECG a ser somado ao valor solicitado';
            case '15':
                return 'FG SEBRAE - ECG já está dentro do valor solicitado';
            case '16':
                return 'FG SEBRAE - ECG via boleto';
            case '20':
                return 'FGI PEAC - ECG pago por terceiros';
            case '21':
                return 'FGT - ECG pago por terceiros';
            default:
                console.log(`Tipo ECG Repasse '${tipoECGRepasse}' desconhecido.`);
        }
    }

    nomeModalidadeOperacional(produto: number) {
        // BNDES ONLINE suporta apenas 3 produtos: 24000, 22500 e 26200 (crédito serviços 4.0).
        // Este último não é aceito pelo FGI PEAC
        switch (produto) {
            case 24000:
                return 'bndes automático';
            case 22500:
                return 'finame';
            case 25100:
                return 'produto bndes crédito digital'
            default:
                console.log(`Modalidade Operacional (Produto) '${produto}' desconhecido.`);
        }
    }

    nomePorteRepasse(porte: string) {
        switch (porte) {
            case '3':
                return 'Microempresa';
            case '4':
                return 'Pequena empresa';
            case '1':
                return 'Média empresa I';
            case '6':
                return 'Média empresa II';
            case '2':
                return 'Grande empresa';
            default:
                console.log(`Porte '${porte}' desconhecido.`);
        }
    }


    nomeNaturezaN02(codigo: string) {
        //    console.log(`código Natureza: '${codigo}'.`);
        const natureza = this.dadosDominio.naturezasN02.filter(item => item.codigo == codigo);
        return natureza.length > 0 ? natureza[0].nome : `Natureza para código '${codigo}' desconhecida.`;
    }

    nomeComplementoNaturezaN02(codigo: string) {
        //    console.log(`código Complemento Natureza: '${codigo}'.`);
        if (!codigo) return '';
        const complementoNatureza = this.dadosDominio.complementosNaturezasN02.filter(item => item.codigo == codigo);
        return complementoNatureza.length > 0 ? complementoNatureza[0].nome : `Complemento '${codigo}' desconhecido.`;
    }

    procuraMunicipio = (text$: Observable<string>) =>
        text$.pipe(
            debounceTime(200),
            distinctUntilChanged(),
            map(term => term.length < 2 ? []
                : this.dadosDominio.municipios.filter(v => v.nome.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
        );

    formataMunicipio = (result: Municipio) => result.nome;

    atribuirOpcaoEnvio(opcaoEnvio: string) {
        this.opcaoEnvioEmit.emit(opcaoEnvio);
    }

    atribuiIndicadorAlteracaoClienteFinal(operacao, indicadorAlteracaoClienteFinal) {
        operacao.indicadorAlteracaoClienteFinal = indicadorAlteracaoClienteFinal;
        if (indicadorAlteracaoClienteFinal == 'S') {
            operacao.dadosOriginaisClienteFinal = {
                cnpjClienteFinal: operacao.cnpjClienteFinal,
                riscoOperacao: operacao.riscoOperacao,
                valorPerdaEsperada: operacao.valorPerdaEsperada,
                naturezaClienteFinal: operacao.naturezaClienteFinal,
                cnaeClienteFinal: operacao.cnaeClienteFinal,
                nomeCnaeClienteFinal: operacao.detalhe.nomeCnaeClienteFinal,
                cnaePortariaGrandeEmpresa: operacao.cnaePortariaGrandeEmpresa,
                nomeCnaePortariaGrandeEmpresa: operacao.detalheCreditoLivre.nomeCnaePortariaGrandeEmpresa,
                receitaBrutaClienteFinal: operacao.receitaBrutaClienteFinal,
                tipoReceitaBruta: operacao.tipoReceitaBruta,
                dataReferenciaReceitaBruta: operacao.dataReferenciaReceitaBruta
            };
        }
        else {
            operacao.cnpjClienteFinal = operacao.dadosOriginaisClienteFinal.cnpjClienteFinal;
            operacao.riscoOperacao = operacao.dadosOriginaisClienteFinal.riscoOperacao;
            operacao.valorPerdaEsperada = operacao.dadosOriginaisClienteFinal.valorPerdaEsperada;
            operacao.naturezaClienteFinal = operacao.dadosOriginaisClienteFinal.naturezaClienteFinal;
            operacao.cnaeClienteFinal = operacao.dadosOriginaisClienteFinal.cnaeClienteFinal;
            operacao.detalhe.nomeCnaeClienteFinal = operacao.dadosOriginaisClienteFinal.nomeCnaeClienteFinal;
            operacao.cnaePortariaGrandeEmpresa = operacao.dadosOriginaisClienteFinal.cnaePortariaGrandeEmpresa;
            operacao.detalheCreditoLivre.nomeCnaePortariaGrandeEmpresa = operacao.dadosOriginaisClienteFinal.nomeCnaePortariaGrandeEmpresa;
            operacao.receitaBrutaClienteFinal = operacao.dadosOriginaisClienteFinal.receitaBrutaClienteFinal;
            operacao.tipoReceitaBruta = operacao.dadosOriginaisClienteFinal.tipoReceitaBruta;
            operacao.dataReferenciaReceitaBruta = operacao.dadosOriginaisClienteFinal.dataReferenciaReceitaBruta;
        }
        this.alteracaoClienteFinalAditivoEmit.emit(indicadorAlteracaoClienteFinal == 'S');
    }

    campoHabilitado(nomeCampo: string) {
        return this.emInclusao || (this.modoEdicao && (this.passivelDeRetificacao(nomeCampo) || this.passivelDeAditivo(nomeCampo)));
    }

    passivelDeRetificacao(nomeCampo: string) {
        return this.modoRetificacao && this.controleHabilitacaoCamposService.passivelDeRetificacao(nomeCampo, this.modalidadeGarantia);
    }

    passivelDeAditivo(nomeCampo: string) {
        return this.modoAditivo && this.controleHabilitacaoCamposService.passivelDeAditivo(nomeCampo, this.modalidadeGarantia);
    }

    exibirTaxaAtualizacaoGarantia() {
        return this.operacao.modalidadeFGI === MODALIDADE_GARANTIA_FGT && this.operacao.id != null;
    }

    modalidadeFGT() {
        return this.operacao.modalidadeFGI === MODALIDADE_GARANTIA_FGT;
    }


    exibirValorTaxaAtualizacaoGarantia(): string {
        if (this.operacao.indexadorAtualizacaoGarantia == null) {
            return "N/A";
        }
        if (this.dadosDominio.indexadores && this.dadosDominio.indexadores.length > 0) {
            let indexadorAtualizacaoGarantiaNome = this.operacao.indexadorAtualizacaoGarantia;

            if (this.operacao.taxaAdicionalAtualizacaoGarantia !== null
                && this.operacao.taxaAdicionalAtualizacaoGarantia > 0) {
                return indexadorAtualizacaoGarantiaNome + " + " + this.operacao.taxaAdicionalAtualizacaoGarantia.toString().replace('.', ',') + " %a.a";
            } else {
                return indexadorAtualizacaoGarantiaNome;
            }
        }
    }

    exibirMunicipioInvestimento() {
        const operacaoRepasseBndes: OperacaoRepasseBndes = <OperacaoRepasseBndes>this.model;
        const modalidade = operacaoRepasseBndes.modalidadeFGI;
        return modalidade == MODALIDADE_GARANTIA_PEAC_CS_RS;
     }

    retornaNomeMunicipioInvestimentoRepasse(): string {
        let municipioInvestimentoRepasse: Municipio[];
        const OperacaoRepasseBndes: OperacaoRepasseBndes = <OperacaoRepasseBndes>this.model;
        const codigoMunicipioInvestimento = OperacaoRepasseBndes.municipioInvestimento;

        if (codigoMunicipioInvestimento !== null) {
            municipioInvestimentoRepasse = this.dadosDominio.municipios.filter(v => v.id == codigoMunicipioInvestimento);
            return municipioInvestimentoRepasse[0]?.nome;
        }
        else {
            return '';
        }
    }

    exibirPeriodicidadeAmortizacao() {
       const operacaoRepasseBndes: OperacaoRepasseBndes = <OperacaoRepasseBndes>this.model;
       const modalidade = operacaoRepasseBndes.modalidadeFGI;
       return  modalidade == MODALIDADE_GARANTIA_FGBS || modalidade == MODALIDADE_GARANTIA_FGT;
    }

    retornaPeriodicidadeAmortizacaoRepasse(): string {
      let peridiocidadeAmortizacaoArray: Array<any> = PERIODICIDADE_AMORTIZACAO;
      const operacaoRepasseBndes: OperacaoRepasseBndes = <OperacaoRepasseBndes> this.model;
      const codigoPeridiocidadeAmortizacao = operacaoRepasseBndes.periodicidadeAmortizacao;
      if (codigoPeridiocidadeAmortizacao !== null) {
        peridiocidadeAmortizacaoArray = peridiocidadeAmortizacaoArray.filter(v => v.codigo == codigoPeridiocidadeAmortizacao);
        return peridiocidadeAmortizacaoArray[0]?.nome;
      } else {
        return '';
      }
    }
}
